module.exports = __webpack_public_path__ + "img/law-careers.b0d436cf.jpg";